<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.korrupsiyagaqarshi')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-1 mb-3">
                <div class="container">
                    <card shadow class="card_radius_no" no-body style="z-index: 10;">
                        <div class="px-4">
                            <div class="text-center mt-2">
                                <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i><span class="news_title">{{$t('submenu.korrupsiyagaqarshi')}}</span></div>
                            </div>
                            <div class="mt-3 py-3 border-top text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                      <el-collapse v-model="activeName" accordion>

                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle7')"
                                                          name="1" class="text-center">
                                          <el-carousel class="carousel_div" :interval="14000" type="card">
                                            <el-carousel-item v-for="n in 10" :key="n">
                                              <img :src="`img/pdf/${n}.jpg`"
                                                   class="slider_doc"
                                                   @click="showImage(`img/pdf/${n}.jpg`)">
                                            </el-carousel-item>
                                          </el-carousel>
                                        </el-collapse-item>

                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle5')"
                                                          name="2" class="text-center">
                                          <img src="img/ill/1.jpg" class="news_image">
                                        </el-collapse-item>
                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle6')"
                                                          name="3" class="text-center">
                                          <img src="img/ill/3.jpg" class="news_image">
                                        </el-collapse-item>
                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle3')"
                                                          name="4" class="text-center">
                                          <img src="img/ill/mansabdor2023.jpg" class="news_image">
                                        </el-collapse-item>
                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle4')"
                                                          name="5" class="text-center">
                                          <img src="img/ill/javobgarlik2023.jpg" class="news_image">
                                        </el-collapse-item>
                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle')"
                                                          name="6" class="text-center">
                                          <img src="img/ill/mansabdor.jpg" class="news_image">
                                        </el-collapse-item>
                                        <el-collapse-item :title="$t('korrupsiyagaqarshi.subtitle2')"
                                                          name="7" class="text-center">
                                          <img src="img/ill/javobgarlik.jpg" class="news_image">
                                        </el-collapse-item>
                                      </el-collapse>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
        </div>
      <el-dialog
          :visible.sync="dialogVisible"
          :append-to-body="true"
          width="50%"
          custom-class="image-dialog"
          top="5vh">
        <img :src="selectedImage" class="dialog-image">
      </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1',
                dialogVisible: false,
                selectedImage: ''
            };
        },
        methods: {
            showImage(imagePath) {
                this.selectedImage = imagePath;
                this.dialogVisible = true;
            }
        }
    }
</script>
<style scoped>
.slider_doc {
  max-height: 400px;
  /*width: 100%;*/
  padding: 20px;
  cursor: pointer;
  transition: transform 0.3s;
}

.slider_doc:hover {
  transform: scale(1.05);
}
::v-deep .el-dialog__header {
  display: none;
}
.dialog-image {
  width: 100%;
  height: auto;
  max-height: 88vh;
  object-fit: contain;
}

:deep(.image-dialog) {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-height: 94vh;
}

:deep(.image-dialog .el-dialog__body) {
  padding: 10px;
  flex: 1;
  background: #d3dce6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
